import React from "react";
import {
  ContentBody,
  ContentHeading,
  ContentLayout,
  CustomTable,
  CustomTableBody,
  DeductionsText,
  NetpaybleText,
  Td,
  Tr,
} from "../../style";
import { Box, Col, FabButton, Flex, Row, Typography } from "../../../ppui";
import { TbDownload } from "react-icons/tb";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";

const EmPortalSalaryStructure = () => {
  const grossSalary = 20000;
  const deductions = 2650;
  const netPayable = grossSalary - deductions;

  const deductionPercentage = (deductions / grossSalary) * 100;
  const netPercentage = 100 - deductionPercentage;

  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Salary Structure
          </Typography>

          <Flex gap={"20"} alignItem="center">
            <Typography variant="h5" mb="0">
              December 2024
            </Typography>
            <FabButton
              size="sm"
              icon={<TbDownload />}
              onClick={() => {}}
              variant="filled"
              shape="box"
            />
          </Flex>
        </ContentHeading>

        <ContentBody Padding>
          <Row>
            <Col sm={12} md={6}>
              <Typography variant="h5" mb={"0"} strong color="primary">
                December 2024
              </Typography>

              <Row my={40}>
                <Col lg={6} xl={4} m={"auto"}>
                  <CircularProgressbarWithChildren
                    value={netPercentage}
                    styles={buildStyles({
                      pathColor: "#004AA8",
                      trailColor: "#EA5743",
                      strokeLinecap: "butt",
                    })}
                  >
                    <Box>
                      <Typography
                        align="center"
                        variant="body1"
                        mb={"5"}
                        color="dark"
                      >
                        Gross Salary
                      </Typography>

                      <Typography
                        align="center"
                        variant="h4"
                        mb={"0"}
                        strong
                        color="dark"
                      >
                        ₹20,000
                      </Typography>
                    </Box>
                  </CircularProgressbarWithChildren>
                </Col>
              </Row>

              <Flex justifyContent="space-between">
                <NetpaybleText>
                  ₹{netPayable.toFixed(2)}
                  <Typography
                    align="center"
                    variant="body1"
                    mb={"0"}
                    color="dark"
                  >
                    Net Payable
                  </Typography>
                </NetpaybleText>

                <DeductionsText>
                  ₹{deductions.toFixed(2)}
                  <Typography
                    align="center"
                    variant="body1"
                    mb={"0"}
                    color="dark"
                  >
                    Deductions
                  </Typography>
                </DeductionsText>
              </Flex>
            </Col>
            <Col sm={12} md={6}>
              <CustomTable style={{height: "100%"}}>
                <CustomTableBody>
                  <Tr>
                    <Td>
                      <Typography variant="body1" mb={"0"}>
                        Basic Pay
                      </Typography>
                    </Td>
                    <Td>
                      <Typography variant="h6" mb={"0"} color="dark" colorVariant="dark">
                        {"₹ 10000.00"}
                      </Typography>
                    </Td>
                  </Tr>

                  <Tr>
                    <Td>
                      <Typography variant="body1" mb={"0"}>
                        HRA
                      </Typography>
                    </Td>
                    <Td>
                      <Typography variant="h6" mb={"0"} color="dark" colorVariant="dark">
                        {"₹ 3600.00"}
                      </Typography>
                    </Td>
                  </Tr>

                  <Tr>
                    <Td>
                      <Typography variant="body1" mb={"0"}>
                        TA
                      </Typography>
                    </Td>
                    <Td>
                      <Typography variant="h6" mb={"0"} color="dark" colorVariant="dark">
                        {"₹ 2000.00"}
                      </Typography>
                    </Td>
                  </Tr>

                  <Tr>
                    <Td>
                      <Typography variant="body1" mb={"0"}>
                        FA
                      </Typography>
                    </Td>
                    <Td>
                      <Typography variant="h6" mb={"0"} color="dark" colorVariant="dark">
                        {"₹ 1250.00"}
                      </Typography>
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>
                      <Typography variant="body1" mb={"0"}>
                        Other Allowance
                      </Typography>
                    </Td>
                    <Td>
                      <Typography variant="h6" mb={"0"} color="dark" colorVariant="dark">
                        {"₹ 500.00"}
                      </Typography>
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>
                      <Typography  variant="body1"
                        mb={"0"}
                        strong
                        color="primary">
                        Total Earnings
                      </Typography>
                    </Td>
                    <Td>
                      <Typography
                        variant="body1"
                        mb={"0"}
                        strong
                        color="primary"
                      >
                        {"₹ 17350.00"}
                      </Typography>
                    </Td>
                  </Tr>
                </CustomTableBody>
              </CustomTable>
            </Col>
          </Row>
        </ContentBody>
      </ContentLayout>
    </>
  );
};

export default EmPortalSalaryStructure;
